import {
  Error,
  GetUsers,
  ManageUserClaims,
  CreateUserDashboard,
  GetClaims,
  GetRoles,
  DeleteUserdashboard,
  UpdateUserAndsubdashboard,   
  UpdateUserdashboard,
  senEmailtouser,
  getUserAndSubuser,
  getUserSubscriber,
  CreatedashNotification,
  getuserNotification,
  DeleteUsersubscripedashboard,
  notnumber
} from "../type";
import { InsertData } from "../../Hooks/InsertData";
import { GetDataToken, GetDataTokenWithheader } from "../../Hooks/getAllData";
import { InsUpdateData } from "../../Hooks/UpdataData";
import DeleteData from "../../Hooks/DeleteData";
export const CreateUserDashboardAction = (data) => async (dispatch) => {
  try {
    const respons = await InsertData(
      `/api/Dashboard/CreateUserDashboard`,
      data
    );
    dispatch({
      type: CreateUserDashboard,
      payload: respons,
      loading: true,
    });
  } catch (e) {
    dispatch({
      type: Error,
      payload: "Error" + e,
    });
  }    
};
export const GetUsersAction = () => async (dispatch) => {
  try {
    const respons = await GetDataToken(`/api/Dashboard/GetAdminsandEditors`);

    dispatch({
      type: GetUsers,
      payload: respons,
      loading: true,
    });
  } catch (e) {
    dispatch({
      type: Error,
      payload: "Error" + e,
    });
  }
};
export const getUserAndSubuserAction = (quirestring) => async (dispatch) => {
  try {
    const respons = await GetDataTokenWithheader(`/api/Dashboard/GetUsersAndSubUsers?${quirestring}`);

    dispatch({
      type: getUserAndSubuser,
      payload: respons,
      loading: true,
    });
  } catch (e) {
    dispatch({
      type: Error,
      payload: "Error" + e,
    });
  }
};
export const getUserSubscriptionAction = (quirestring) => async (dispatch) => {
  try {
    const respons = await GetDataTokenWithheader(`/api/Dashboard/GetUserSubscription?${quirestring}`);

    dispatch({
      type: getUserSubscriber,
      payload: respons,
      loading: true,
    });
  } catch (e) {
    dispatch({
      type: Error,
      payload: "Error" + e,
    });
  }
};

export const ManageUserClaimsAction = (data) => async (dispatch) => {
  try {
    const response = await InsertData(`/api/Dashboard/ManageUserClaims`,data);
    dispatch({
      type: ManageUserClaims,
      payload: response,
      loading: true,
    });
  } catch (e) {
    dispatch({
      type: Error,
      payload: "Error " + e,
    });
  }
};
export const GetClaimsAction = () => async (dispatch) => {
  try {
    const respons = await GetDataToken(`/api/Dashboard/GetClaims`);
    dispatch({
      type: GetClaims,
      payload: respons,
      loading: true,
    });
  } catch (e) {
    dispatch({
      type: Error,
      payload: "Error" + e,
    });
  }
};
export const GetRolesAction = () => async (dispatch) => {
  try {
    const respons = await GetDataToken(`/api/Dashboard/GetRoles`);
    dispatch({
      type: GetRoles,
      payload: respons,
      loading: true,
    });
  } catch (e) {
    dispatch({
      type: Error,
      payload: "Error" + e,
    });
  }
};
export const DeleteUserdashboardAction = (id) => async (dispatch) => {
  try {
    const response = await DeleteData(
      `/api/Dashboard/DeleteUser?userId=${id}`
    );
    dispatch({
      type: DeleteUserdashboard,
      payload: response,
      loading: true,
    });
  } catch (e) {
    dispatch({
      type: Error,
      payload: "Error " + e,
    });
  }
};
export const DeleteUsersubscripedashboardAction = (id) => async (dispatch) => {
  try {
    const response = await DeleteData(
      `/api/Dashboard/DeleteUserSubscription?subscriptionId=${id}`
    );
    dispatch({
      type: DeleteUsersubscripedashboard,
      payload: response,
      loading: true,
    });
  } catch (e) {
    dispatch({
      type: Error,
      payload: "Error " + e,
    });
  }
};
export const UpdateUserdashboardAction = (data) => async (dispatch) => {
  try {
    const response = await InsUpdateData(
      `/api/Dashboard/ManageUser`,
      data
    );
    dispatch({
      type: UpdateUserdashboard,
      payload: response,
      loading: true,
    });
  } catch (e) {
    dispatch({
      type: Error,
      payload: "Error " + e,
    });
  }
};

export const UpdateUserAndSubuserdashboardAction = (data) => async (dispatch) => {
  try {
    const response = await InsUpdateData(
      `/api/Dashboard/UpdateUserOrSubUser`,
      data
    );
    dispatch({
      type: UpdateUserAndsubdashboard,
      payload: response,
      loading: true,
    });
  } catch (e) {
    dispatch({
      type: Error,
      payload: "Error " + e,
    });
  }
};
export const SendEmailltouserDashboardAction = (data) => async (dispatch) => {
  try {
    const respons = await InsertData(
      `/api/Dashboard/SendEmailToUser`,
      data
    );
    dispatch({
      type: senEmailtouser,
      payload: respons,
      loading: true,
    });
  } catch (e) {
    dispatch({
      type: Error,
      payload: "Error" + e,
    });
  }    
};
export const CreateUserDashboardNotifiactionAction = (data) => async (dispatch) => {
  try {
    const respons = await InsertData(
      `/api/Notification`,
      data
    );
    dispatch({
      type: CreatedashNotification,
      payload: respons,
      loading: true,
    });
  } catch (e) {
    dispatch({
      type: Error,
      payload: "Error" + e,
    });
  }    
};
export const GetuserNotificationAction = () => async (dispatch) => {
  try {
    const respons = await GetDataToken(`/api/Notification`);
    dispatch({
      type: getuserNotification,
      payload: respons,
      loading: true,
    });
  } catch (e) {
    dispatch({
      type: Error,
      payload: "Error" + e,
    });
  }
};

export const GetuserNotificationNumberAction = () => async (dispatch) => {
  try {
    const respons = await GetDataToken(`/api/Notification/GetNotificationsCount`);
    dispatch({
      type: notnumber,
      payload: respons,
      loading: true,
    });
  } catch (e) {
    dispatch({
      type: Error,
      payload: "Error" + e,
    });
  }
};